export const OPEN_BROKER_MODAL = 'OPEN_BROKER_MODAL';
export const BROKER_ID_STATE = 'BROKER_ID_STATE';
export const SET_DELETE_INCOMPLETE_REGISTERED_BROKER_MODAL = 'SET_DELETE_INCOMPLETE_REGISTERED_BROKER_MODAL';

export const setBrokerModalOpen = (state) => (dispatch) => {
    dispatch({ type: OPEN_BROKER_MODAL, state });
};

export const setBrokerId = (state) => (dispatch) => {
    dispatch({ type: BROKER_ID_STATE, state });
};

export const setDeleteIncompleteRegisteredBrokerModal = (state) => (dispatch) => {
    dispatch({ type: SET_DELETE_INCOMPLETE_REGISTERED_BROKER_MODAL, state });
};

export default {
    OPEN_BROKER_MODAL,
    setBrokerModalOpen,
    BROKER_ID_STATE,
    setBrokerId,
    SET_DELETE_INCOMPLETE_REGISTERED_BROKER_MODAL,
    setDeleteIncompleteRegisteredBrokerModal,
};
